import "../../../common/js/3rdparty/date.js";

import $ from "webpack-zepto";
window.$ = $;

import Ajax from "../../../common/js/Ajax.js";
import Navigation from "../../../common/js/Navigation.js";
import WidgetLoader from "../../../common/js/WidgetLoader.js";
import ZoomImage from "../../../common/js/image/ZoomImage.js";

import DatePickerWidget from "../../../common/js/datepicker/DatePickerWidget.js";

import BetWidget from "./bet/BetWidget.js";
import FinishPasswordResetWidget from "./auth/FinishPasswordResetWidget.js";
import LoginWidget from "./auth/LoginWidget.js";
import LogoutWidget from "./auth/LogoutWidget.js";
import RegisterWidget from "./auth/RegisterWidget.js";
import ResultsWidget from "./admin/result/ResultsWidget.js";
import ScoresWidget from "./score/ScoresWidget.js";
import SeasonWidget from "./admin/season/SeasonWidget.js";
import SeasonsWidget from "./admin/season/SeasonsWidget.js";
import StartPasswordResetWidget from "./auth/StartPasswordResetWidget.js";
import TeamsWidget from "./admin/team/TeamsWidget.js";
import TippspielWidget from "./TippspielWidget.js";

$(() => {
	Ajax.initialize();
	Navigation.initialize();
	ZoomImage.initialize();

	WidgetLoader.add("DatePickerWidget", DatePickerWidget);

	WidgetLoader.add("BetWidget", BetWidget);
	WidgetLoader.add("FinishPasswordResetWidget", FinishPasswordResetWidget);
	WidgetLoader.add("LoginWidget", LoginWidget);
	WidgetLoader.add("LogoutWidget", LogoutWidget);
	WidgetLoader.add("RegisterWidget", RegisterWidget);
	WidgetLoader.add("ResultsWidget", ResultsWidget);
	WidgetLoader.add("ScoresWidget", ScoresWidget);
	WidgetLoader.add("SeasonWidget", SeasonWidget);
	WidgetLoader.add("SeasonsWidget", SeasonsWidget);
	WidgetLoader.add("StartPasswordResetWidget", StartPasswordResetWidget);
	WidgetLoader.add("TeamsWidget", TeamsWidget);
	WidgetLoader.add("TippspielWidget", TippspielWidget);

	WidgetLoader.initialize();
});
